import React, { useContext, useState, useEffect } from "react";
import { Form, Button, Container, Row, Col, Alert } from "react-bootstrap";
import { FaEnvelope } from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { InfoContext } from "../providers/InfosContextProvider";

const SellProperty = () => {
  const { texts } = useContext(InfoContext);
  const [formData, setFormData] = useState({
    nome: "",
    email: "",
    telefone: "",
    mensagem: "",
  });
  const [showAlert, setShowAlert] = useState(false);
  const [showError, setShowError] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = new FormData();
    Object.keys(formData).forEach((key) => data.append(key, formData[key]));
    data.append("type", "selling");

    fetch("/api/send-email.php", {
      method: "POST",
      body: data,
    })
      .then((response) => {
        if (response.status === 200) {
          setShowAlert(true);
          setShowError(false);
          setFormData({
            nome: "",
            email: "",
            telefone: "",
            mensagem: "",
          });
        } else {
          setShowAlert(false);
          setShowError(true);
        }
      })
      .catch((error) => {
        console.error("Erro:", error);
        setShowAlert(false);
        setShowError(true);
      });
  };

  useEffect(() => {
    if (showAlert || showError) {
      const timer = setTimeout(() => {
        setShowAlert(false);
        setShowError(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [showAlert, showError]);

  useEffect(() => {
    const pageTitle = texts?.venderCasa?.titulo || "Vender";
    document.title = `${pageTitle} | Casas do Nabão`;
  }, [texts]);

  return (
    <>
      <Header />
      <Container className="vender-casa">
        <div
          className="contact-card p-md-5 p-4 shadow-sm bg-white rounded-3"
          style={{ borderTop: "4px solid #a02020" }}
        >
          <h2
            className="mb-4 fw-bold"
            style={{
              color: "#333",
              borderBottom: "2px solid #f0f0f0",
              paddingBottom: "15px",
            }}
          >{`${texts.venderCasa.titulo}`}</h2>
          <p className="text-secondary" style={{ fontSize: "1.05rem" }}>
            {`${texts.venderCasa.subtitulo}`}
          </p>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={6}>
                <Form.Group controlId="nome" className="mb-3">
                  <Form.Label>{`${texts.venderCasa.nome}`}</Form.Label>
                  <Form.Control
                    type="text"
                    name="nome"
                    placeholder={`${texts.venderCasa.nomePlaceholder}`}
                    value={formData.nome}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="email" className="mb-3">
                  <Form.Label>{`${texts.venderCasa.email}`}</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder={`${texts.venderCasa.emailPlaceholder}`}
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group controlId="telefone" className="mb-3">
                  <Form.Label>{`${texts.venderCasa.telefone}`}</Form.Label>
                  <Form.Control
                    type="tel"
                    name="telefone"
                    placeholder={`${texts.venderCasa.telefonePlaceholder}`}
                    value={formData.telefone}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group controlId="mensagem" className="mb-3">
              <Form.Label>{`${texts.venderCasa.mensagem}`}</Form.Label>
              <Form.Control
                as="textarea"
                rows={5}
                name="mensagem"
                placeholder={`${texts.venderCasa.mensagemPlaceholder}`}
                value={formData.mensagem}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <div className="text-center">
              <Button className="mt-3 btn-vender" type="submit">
                <FaEnvelope className="me-2" />
                {`${texts.venderCasa.enviar}`}
              </Button>
              {showAlert && (
                <Alert variant="success" className="mt-3">
                  {`${texts.venderCasa.msgOK}`}
                </Alert>
              )}
              {showError && (
                <Alert variant="danger" className="mt-3">
                  {`${texts.venderCasa.msgErro}`}
                </Alert>
              )}
            </div>
          </Form>
        </div>
      </Container>
      <div className="div-footer">
        <Footer />
      </div>
    </>
  );
};

export default SellProperty;
